<template>
  <div v-show="visible" :class="[$style.wrapper, {[$style.screenfull]: screenfull}]">
    <div :class="[$style.contentBox, {[$style.boxcard] : !screenfull} ]">
        <div :class="[$style.boxHeader, {[$style.mobileHeader] : screenfull} ]">
            <div :class="$style.headertitle">{{!screenfull? title : ''}}</div>
            <i :class="$style.boxClose" @click="onClose"></i>
        </div>
        <div :class="$style.splitline" v-if="!screenfull"></div>
        <div :class="$style.boxBody">
            <slot name="content"></slot>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    name:'Dialog',
    props:{
        title:{
            type: String,
            default: ''
        },
        screenfull:{
            type:Boolean,
            default:false
        },
        visible:{
            type:Boolean,
            default:false
        }
    },
    methods:{
        onClose(){
            this.$emit('update:visible', false)
        }
    }
}
</script>

<style lang="scss" module>
.wrapper{
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: #7777777f;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
}
.screenfull{
    background-color: #fff;
}
.contentBox{
  background: #fff;
  padding: 10px 20px;
  width: 450px;
  text-align: center;
  box-sizing: border-box;
  .boxcard{
    box-shadow: 0 12px 30px 0 rgba(0, 0, 0, .05);
  }
  .boxHeader{
    padding: 20px 0;
    font-size: 20px;
    font-weight: bold;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
    .headertitle{
        width: 100%;
        text-align: left;
    }
    .boxClose{
        flex-shrink: 0;
        background: url('./assets/close.svg') no-repeat;
        width: 16px;
        height: 16px;
        cursor: pointer;
    }
  }
  .mobileHeader{
    padding: 0;
   .boxClose{
        margin-right: 50px;
        margin-bottom: -20px;
    }
  }
  .boxBody{
    padding: 25px 20px;
  }
}
.splitline{
    width: 100%;
    height: 1px;
    background: #efefef;
}
</style>